import { ERROR_CODES } from 'common/constants'
import { getTrimmedData, parseDataForSubmit, tryCallApi } from 'common/helpers'
import { FixedAssetsService } from 'common/open-api'
import { getAxiosSilent } from 'common/open-api/helper'
import cloneDeep from 'lodash/cloneDeep'
import { useEffect, useState } from 'react'

// Whether the API allows correcting the fixed asset, asked with a dry-run correction of its current data. Skips the
// request when disabled or without a biid; stays false until the request succeeds, and a failed request settles as false.
// isRetroActiveClosed flags the API rejecting with ERR_CORRECTION_MONTH_RETRO_ACTIVE_HAS_CLOSED.
// isCheckingCorrectable is true until the request for the current asset settles (already true on the first render).
export const useIsCorrectable = (asset?: any, enabled = true) => {
  const [isCorrectable, setIsCorrectable] = useState(false)
  const [isRetroActiveClosed, setIsRetroActiveClosed] = useState(false)
  const [checkedAsset, setCheckedAsset] = useState<any>()
  const biid: string | undefined = asset?.biid

  useEffect(() => {
    if (!enabled || !biid) return
    let cancelled = false
    const checkCorrectable = async () => {
      const response = await tryCallApi(FixedAssetsService.putFixedAssetsByBiidCorrect)(
        biid,
        { ...parseDataForSubmit(getTrimmedData(cloneDeep(asset))), dry_run: true },
        getAxiosSilent()
      )
      if (cancelled) return
      setIsCorrectable(!response.error && !!response.data?.data)
      setIsRetroActiveClosed(
        !!response.error?.response?.data?.errors?.some(
          (error: any) => error?.code === ERROR_CODES.ERR_CORRECTION_MONTH_RETRO_ACTIVE_HAS_CLOSED
        )
      )
      setCheckedAsset(asset)
    }

    checkCorrectable()
    return () => {
      cancelled = true
    }
  }, [asset, biid, enabled])

  return { isCorrectable, isRetroActiveClosed, isCheckingCorrectable: enabled && !!biid && checkedAsset !== asset }
}
